import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import Breadcrumb from '../components/Breadcrumb';
import api from '../utils/api';

// Language-specific labels
const labels = {
  telugu: {
    title: 'సభ్యుల నమోదు',
    subtitle: 'దిగువ ఫారమ్‌ను పూరించడం ద్వారా సభ్యుడిగా నమోదు చేయబడుతుంది. అన్ని ఫీల్డ్‌లు నిర్బంధకరమైనవి.',
    referralName: 'ధృవీకరించిన వారు',
    mobileNumber: 'మొబైల్ నంబర్',
    mobileHelper: '10-అంకెల మొబైల్ నంబర్',
    mobileVerified: '✓ మొబైల్ నంబర్ ధృవీకరించబడింది',
    mobileValidating: 'ధృవీకరణ...',
    mobileExists: 'ఈ మొబైల్ నంబర్ ఇప్పటికే నమోదు చేయబడింది',
    fullName: 'పూర్తి పేరు',
    surname: 'ఇంటి పేరు',
    gotram: 'గోత్రం',
    familyConnection: 'కుటుంబం గురించి ఎలా తెలుసుకున్నారు?',
    familyConnectionRelative: 'బంధువు',
    familyConnectionCoworker: 'సహోద్యోగి',
    familyConnectionNeighbor: 'పొరుగువారు',
    familyConnectionOther: 'ఇతర',
    familyConnectionReason: 'ఎలా తెలుసో సవివరంగా తెలపండి',
    familyMembers: 'కుటుంబం మొత్తం సభ్యులు',
    occupation: 'వృత్తి',
    occupationVedam: 'వేదం',
    occupationSaastram: 'శాస్త్రం',
    occupationSmaartham: 'స్మార్థం',
    occupationLoukikam: 'లౌకికం',
    occupationVantavaru: 'వంటవారు',
    kidsEducation: 'సంతానాల విద్యాభ్యాస రకం',
    kidsEducationVedam: 'వేదం',
    kidsEducationSaastram: 'శాస్త్రం',
    kidsEducationSmaartham: 'స్మార్థం',
    kidsEducationLoukikam: 'లౌకికం',
    noKids: 'సంతానం లేదు',
    kidsEducationOther: 'ఇతర',
    intercasteMarriage: 'కనీసం 3 తరాలలో ఎటువంటి కులాంతర వివాహం జరగలేదని మీకు ఖచ్చితమైన వివరము తెలుసా?',
    sandhyaVandanam: 'ఎవరైనా కుటుంబ సభ్యులు సంధ్యావందనం చేస్తారా?',
    sonGrandsonEducation: 'ఎవరైనా అతని కుమారుడు/మనవడు వేదం/స్మార్థం/శాస్త్రం చదివారా/చదువుతున్నారా?',
    hasAgnihotram: 'వీరు అగ్నిహోత్రీకులా?',
    hasAnushtanaMantras: 'వీరి ఇంట్లో అనుష్ఠాన మంత్రాలు ఉన్నాయా?',
    belongsToGuruParampara: 'వీరి కుటుంబం ఏదైనా గురు పరంపరలో ఉన్నారా?',
    visitsVedaPathasala: 'వీరి కుటుంబం వేద పాఠశాలలను తరచుగా సందర్శిస్తుంటారా లేదా ఏదైనా సహాయం చేస్తుంటారా?',
    daughtersMarriedToScholars: 'వీరి కుటుంబంలో ఎవరైనా ఆడపిల్లల్ని వేద/స్మార్త/శాస్త్ర పండితులకు ఇచ్చి వివాహం చేశారా?',
    doesDasaraNavaratri: 'వీరి కుటుంబంలో దసరా నవరాత్రులు కానీ/వేద ఆశీర్వచనం చేయిస్తుంటారా?',
    followsMadiBhojanam: 'వీరి కుటుంబంలో మడిభోజనం/శుచి/శుభ్రం/మైల పాటిస్తారా?',
    performsVratasRegularly: 'వీరి కుటుంబంలో వ్రతాలు/నోములు/ఆబ్దికాలు నియమంగా చేస్తుంటారా?',
    hadFiveDayFunction: 'వీరి కుటుంబంలో 5 రోజుల ఉపనయనం/5 రోజుల వివాహం జరిగాయా?',
    doesDeeparadhana: 'వీరి కుటుంబంలో దీపారాధన/దేవతార్చన ఉన్నాయా?',
    isCommitteeEndorsed: 'కమిటీ ఆమోదితమైన సభ్యుడు?',
    yes: 'అవును',
    no: 'కాదు',
    iDontKnow: 'నాకు తెలియదు',
    submit: 'నమోదు సమర్పించండి',
    clearForm: 'ఫారమ్‌ను క్లియర్ చేయండి',
    selectOption: '-- ఎంపికను ఎంచుకోండి --',
    memberAlreadyExists: 'సభ్యుడు ఇప్పటికే ఉంది',
    memberDetails: 'ఈ మొబైల్ నంబర్ ఇప్పటికే నమోదు చేయబడింది. వివరాలు:',
    registrationSuccess: 'నమోదు విజయవంతమైంది!',
    close: 'మూసివేయు'
  },
  sanskrit: {
    title: 'सदस्य पञ्जीकरणम्',
    subtitle: 'अधोलिखितं फलकं पूरयित्वा सदस्यत्वं पञ्जीकुर्वन्तु। सर्वे क्षेत्रा: अनिवार्यः।',
    referralName: 'संदर्भ नाम',
    mobileNumber: 'मोबाइल संख्या',
    mobileHelper: '10-अङ्कीय मोबाइल संख्या',
    mobileVerified: '✓ मोबाइल संख्या सत्यापितः',
    mobileValidating: 'सत्यापनम्...',
    mobileExists: 'एषा मोबाइल संख्या पञ्जीकरणम् वर्तते',
    fullName: 'पूर्ण नाम (उपनाम विना)',
    surname: 'उपनाम',
    gotram: 'गोत्रम्',
    familyConnection: 'कथं कुटुम्ब पञ्जानन्?',
    familyConnectionRelative: 'सम्बन्धी',
    familyConnectionCoworker: 'सहकर्मी',
    familyConnectionNeighbor: 'पडोसी',
    familyConnectionOther: 'अन्य',
    familyConnectionReason: 'कारणं वक्षयन्तु',
    familyMembers: 'कुटुम्ब कुल सदस्य: संख्या',
    occupation: 'व्यवसाय',
    occupationVedam: 'वेदम्',
    occupationSaastram: 'शास्त्रम्',
    occupationSmaartham: 'स्मार्थम्',
    occupationLoukikam: 'लौकिकम्',
    occupationVantavaru: 'वंटवः',
    kidsEducation: 'तनयानां शिक्षा प्रकार:',
    kidsEducationVedam: 'वेदम्',
    kidsEducationLoukikam: 'लौकिकम्',
    kidsEducationSmaartham: 'स्मार्थम्',
    kidsEducationSaastram: 'शास्त्रम्',
    noKids: 'संतानाः नास्ति',
    kidsEducationOther: 'अन्य',
    intercasteMarriage: 'कमपक्षे त्रिषु पीढीषु वर्णसंकरविवाहे भवन्तः सर्वथा निश्चितः?',
    sandhyaVandanam: 'कोऽपि कुटुम्ब सदस्य: संध्या वन्दनं करोति अथ न?',
    sonGrandsonEducation: 'कोऽपि तस्य पुत्र:/पौत्र: वेद/स्मार्थ/शास्त्रे आसीत् अथ न?',
    hasAgnihotram: 'कोऽपि अग्निहोत्रं करोति अथ न?',
    hasAnushtanaMantras: 'भवनः गृहे अनुष्ठानमन्त्राः सन्ति वा?',
    belongsToGuruParampara: 'किं भवनः कुटुम्बः कस्यापि गुरुपरम्परायाः भागः अस्ति?',
    visitsVedaPathasala: 'किं भवनः कुटुम्बः वेदपाठशालाः वारंवारं पश्यति वा सहायतां करोति वा?',
    daughtersMarriedToScholars: 'भवनः कुटुम्बे कन्याः वेद/स्मार्त/शास्त्रपण्डितेभ्यः दत्ताः वा?',
    doesDasaraNavaratri: 'किं भवनः कुटुम्बे दशरानवरात्रयः वा वेदाशीर्वचनं वा क्रियते?',
    followsMadiBhojanam: 'किं भवनः कुटुम्बे मडिभोजनं/शुचि/शुद्धं/मैला पाल्यते?',
    performsVratasRegularly: 'किं भवनः कुटुम्बे व्रतानि/नोमुलु/आब्दिकाः नियमेन क्रियन्ते?',
    hadFiveDayFunction: 'भवनः कुटुम्बे ५ दिनानि उपनयनं/५ दिनानि विवाहः अभवत् वा?',
    doesDeeparadhana: 'भवनः कुटुम्बे दीपाराधनं/देवतार्चनं वर्तते वा?',
    isCommitteeEndorsed: 'समिति अनुमोदित सदस्य:?',
    yes: 'आम्',
    no: 'न',
    iDontKnow: 'न जानामि',
    submit: 'पञ्जीकरणं प्रस्तुतु',
    clearForm: 'फलकं शोधयन्तु',
    selectOption: '-- कृपया विकल्पं चिनुत --',
    memberAlreadyExists: 'सदस्य वर्तते',
    memberDetails: 'एषा मोबाइल संख्या पञ्जीकरणम् वर्तते। वर्णन:',
    registrationSuccess: 'पञ्जीकरणं सफलं अभवत्!',
    close: 'बन्धयन्तु'
  }
};

export default function MemberRegistration() {
  const { lang } = useLanguage();
  const { user } = useAuth();
  const text = labels[lang] || labels.telugu;

  // Form fields
  const [referralMemberId, setReferralMemberId] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [fullNameWithoutSurname, setFullNameWithoutSurname] = useState('');
  const [surname, setSurname] = useState('');
  const [gotram, setGotram] = useState('');
  const [howYouKnowAboutFamily, setHowYouKnowAboutFamily] = useState('');
  const [howYouKnowAboutFamilyOther, setHowYouKnowAboutFamilyOther] = useState('');
  const [familyTotalMembers, setFamilyTotalMembers] = useState('');
  const [occupation, setOccupation] = useState([]);
  const [kidsEducationType, setKidsEducationType] = useState('');
  const [intercasteMarriageInThreeGenerations, setIntercasteMarriageInThreeGenerations] = useState('');
  const [familySandhyaVandanam, setFamilySandhyaVandanam] = useState('I don\'t know');
  const [sonGrandsonEducation, setSonGrandsonEducation] = useState('I don\'t know');
  const [hasAgnihotram, setHasAgnihotram] = useState('');
  const [isCommitteeEndorsed, setIsCommitteeEndorsed] = useState('No');

  const [hasAnushtanaMantras, setHasAnushtanaMantras] = useState('I don\'t know');
  const [belongsToGuruParampara, setBelongsToGuruParampara] = useState('I don\'t know');
  const [visitsVedaPathasala, setVisitsVedaPathasala] = useState('I don\'t know');
  const [daughtersMarriedToScholars, setDaughtersMarriedToScholars] = useState('I don\'t know');
  const [doesDasaraNavaratri, setDoesDasaraNavaratri] = useState('I don\'t know');
  const [followsMadiBhojanam, setFollowsMadiBhojanam] = useState('I don\'t know');
  const [performsVratasRegularly, setPerformsVratasRegularly] = useState('I don\'t know');
  const [hadFiveDayFunction, setHadFiveDayFunction] = useState('I don\'t know');
  const [doesDeeparadhana, setDoesDeeparadhana] = useState('I don\'t know');

  // State management
  const [referralMembers, setReferralMembers] = useState([]);
  const [loadingReferrals, setLoadingReferrals] = useState(true);
  const [mobileCheckLoading, setMobileCheckLoading] = useState(false);
  const [mobileValidated, setMobileValidated] = useState(false);
  const [mobileCheckError, setMobileCheckError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Existing member dialog
  const [existingMemberDialog, setExistingMemberDialog] = useState(false);
  const [existingMember, setExistingMember] = useState(null);

  // Fetch referral members on mount
  useEffect(() => {
    fetchReferralMembers();
  }, []);

  const fetchReferralMembers = async () => {
    try {
      setLoadingReferrals(true);
      const response = await api.get('/api/startup-members/referral-members');
      if (!response.ok) throw new Error('Failed to fetch referral members');
      const data = await response.json();
      setReferralMembers(data);
    } catch (error) {
      console.error('Error fetching referral members:', error);
      setErrorMessage(text.selectOption);
    } finally {
      setLoadingReferrals(false);
    }
  };

  // Handle restricted multi-select occupation
  const handleOccupationChange = (event) => {
    const value = event.target.value;
    const lastSelected = value[value.length - 1];
    
    if (!lastSelected) {
      setOccupation([]);
      return;
    }

    if (lastSelected === 'Smaartham' || lastSelected === 'Loukikam' || lastSelected === 'Vantavaru') {
      setOccupation([lastSelected]);
    } else if (lastSelected === 'Vedam' || lastSelected === 'Saastram') {
      const filtered = value.filter(v => v === 'Vedam' || v === 'Saastram');
      setOccupation(filtered);
    }
  };

  // Determine category symbol for display
  const getCategorySymbol = () => {
    if (occupation.includes('Vedam') && hasAgnihotram === 'Yes') {
      return { label: 'Platinum Member', color: '#E5E4E2', icon: '🏆' };
    }
    if (occupation.includes('Vedam') || occupation.includes('Saastram') || kidsEducationType === 'Vedam') {
      return { label: 'Gold Member', color: '#FFD700', icon: '🥇' };
    }
    if (occupation.includes('Smaartham') || occupation.includes('Vantavaru')) {
      return { label: 'Silver Member', color: '#C0C0C0', icon: '🥈' };
    }
    if (occupation.includes('Loukikam')) {
      return { label: 'Bronze Member', color: '#CD7F32', icon: '🥉' };
    }
    return null;
  };

  const categoryInfo = getCategorySymbol();
  const isLoukikam = occupation.includes('Loukikam');
  const isVedaShastra = occupation.includes('Vedam') || occupation.includes('Saastram');

  // Validate and check mobile number
  const handleMobileNumberChange = async (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setMobileNumber(value);
    setMobileValidated(false);
    setMobileCheckError('');
    setExistingMember(null);

    if (value.length === 10) {
      try {
        setMobileCheckLoading(true);
        const response = await api.get(`/api/startup-members/check-mobile?mobileNumber=${value}`);

        if (!response.ok) throw new Error('Failed to check mobile number');
        const data = await response.json();

        if (data.exists) {
          setExistingMember(data.member);
          setExistingMemberDialog(true);
          setMobileValidated(false);
          setMobileCheckError(text.mobileExists);
        } else {
          setMobileValidated(true);
          setMobileCheckError('');
        }
      } catch (error) {
        console.error('Error checking mobile number:', error);
        setMobileCheckError('Error validating mobile number');
        setMobileValidated(false);
      } finally {
        setMobileCheckLoading(false);
      }
    }
  };

  // Check if all required fields are filled
  const areAllFieldsFilled = () => {
    return (
      referralMemberId !== '' &&
      mobileValidated &&
      fullNameWithoutSurname.trim() !== '' &&
      surname.trim() !== '' &&
      gotram.trim() !== '' &&
      howYouKnowAboutFamily !== '' &&
      (howYouKnowAboutFamily !== 'Other' || howYouKnowAboutFamilyOther.trim() !== '') &&
      familyTotalMembers !== '' &&
      occupation.length > 0 &&
      (isLoukikam ? true : kidsEducationType !== '') &&
      (isVedaShastra || isLoukikam ? true : intercasteMarriageInThreeGenerations !== '') &&
      familySandhyaVandanam !== '' &&
      sonGrandsonEducation !== '' &&
      (isLoukikam ? true : hasAgnihotram !== '') &&
      isCommitteeEndorsed !== '' &&
      hasAnushtanaMantras !== '' &&
      belongsToGuruParampara !== '' &&
      visitsVedaPathasala !== '' &&
      daughtersMarriedToScholars !== '' &&
      doesDasaraNavaratri !== '' &&
      followsMadiBhojanam !== '' &&
      performsVratasRegularly !== '' &&
      hadFiveDayFunction !== '' &&
      doesDeeparadhana !== ''
    );
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!areAllFieldsFilled()) {
      setErrorMessage('Please fill all required fields');
      return;
    }

    try {
      setSubmitting(true);
      setErrorMessage('');
      setSuccessMessage('');

      // Determine specific field values based on occupation
      const finalIntercasteMarriage = isVedaShastra 
        ? 'Yes' 
        : isLoukikam 
        ? (intercasteMarriageInThreeGenerations || "I don't know") 
        : intercasteMarriageInThreeGenerations;

      const payload = {
        referralMemberId,
        mobileNumber,
        fullNameWithoutSurname,
        surname,
        gotram,
        howYouKnowAboutFamily,
        howYouKnowAboutFamilyOther: howYouKnowAboutFamily === 'Other' ? howYouKnowAboutFamilyOther : null,
        familyTotalMembers: parseInt(familyTotalMembers),
        occupation,
        kidsEducationType: kidsEducationType,
        intercasteMarriageInThreeGenerations: finalIntercasteMarriage,
        familySandhyaVandanam,
        sonGrandsonEducation,
        hasAgnihotram: isLoukikam ? 'No' : hasAgnihotram,
        isCommitteeEndorsed,
        hasAnushtanaMantras,
        belongsToGuruParampara,
        visitsVedaPathasala,
        daughtersMarriedToScholars,
        doesDasaraNavaratri,
        followsMadiBhojanam,
        performsVratasRegularly,
        hadFiveDayFunction,
        doesDeeparadhana,
        registeredBy: user?.firstName || 'Unknown'
      };

      const response = await api.post('/api/startup-members/register', payload);

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Registration failed');
      }

      const result = await response.json();
      setSuccessMessage(`${text.registrationSuccess} வணக்கம், ${result.member.fullName}`);

      // Refresh referrals with latest data
      fetchReferralMembers();

      // Reset form
      setReferralMemberId('');
      setMobileNumber('');
      setFullNameWithoutSurname('');
      setSurname('');
      setGotram('');
      setHowYouKnowAboutFamily('');
      setHowYouKnowAboutFamilyOther('');
      setFamilyTotalMembers('');
      setOccupation([]);
      setKidsEducationType('');
      setIntercasteMarriageInThreeGenerations('');
      setFamilySandhyaVandanam('I don\'t know');
      setSonGrandsonEducation('I don\'t know');
      setHasAgnihotram('');
      setIsCommitteeEndorsed('No');
      setMobileValidated(false);

      setHasAnushtanaMantras('I don\'t know');
      setBelongsToGuruParampara('I don\'t know');
      setVisitsVedaPathasala('I don\'t know');
      setDaughtersMarriedToScholars('I don\'t know');
      setDoesDasaraNavaratri('I don\'t know');
      setFollowsMadiBhojanam('I don\'t know');
      setPerformsVratasRegularly('I don\'t know');
      setHadFiveDayFunction('I don\'t know');
      setDoesDeeparadhana('I don\'t know');

      // Keep success message visible
      setTimeout(() => setSuccessMessage(''), 5000);
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage(error.message || 'Registration failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <Breadcrumb
        items={[
          { label: lang === 'telugu' ? 'సభ్యుల నమోదు విభాగం' : 'सदस्य पञ्जीकरण विभागः', path: '/member-management' },
          { label: text.title }
        ]}
      />
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, color: '#7f4b2d' }}>
        {text.title}
      </Typography>
      <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
        {text.subtitle}
      </Typography>

      {errorMessage && <Alert severity="error" sx={{ mb: 3 }}>{errorMessage}</Alert>}
      {successMessage && <Alert severity="success" sx={{ mb: 3 }}>{successMessage}</Alert>}
      {mobileCheckError && <Alert severity="warning" sx={{ mb: 2 }}>{mobileCheckError}</Alert>}

      <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
              {/* Referral Name Dropdown - REQUIRED */}
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>{text.referralName} *</InputLabel>
                <Select
                  label={`${text.referralName} *`}
                  value={referralMemberId}
                  onChange={(e) => setReferralMemberId(e.target.value)}
                  disabled={loadingReferrals}
                >
                  <MenuItem value="">
                    <em>{text.selectOption}</em>
                  </MenuItem>
                  {referralMembers.map((member) => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Mobile Number (with validation) */}
              <TextField
                label={`${text.mobileNumber} *`}
                fullWidth
                type="tel"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                inputProps={{ maxLength: 10 }}
                placeholder={text.mobileHelper}
                variant="outlined"
                disabled={mobileCheckLoading}
                error={mobileCheckError !== '' && mobileNumber.length === 10}
                helperText={
                  mobileCheckLoading
                    ? text.mobileValidating
                    : mobileValidated && mobileNumber.length === 10
                    ? text.mobileVerified
                    : mobileCheckError
                    ? mobileCheckError
                    : text.mobileHelper
                }
                size="small"
                InputProps={{
                  endAdornment: mobileCheckLoading ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null
                }}
              />

              {/* Full Name without Surname */}
              <TextField
                label={`${text.fullName} *`}
                fullWidth
                value={fullNameWithoutSurname}
                onChange={(e) => setFullNameWithoutSurname(e.target.value)}
                disabled={!mobileValidated}
                variant="outlined"
                size="small"
              />

              {/* Surname */}
              <TextField
                label={`${text.surname} *`}
                fullWidth
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                disabled={!mobileValidated}
                variant="outlined"
                size="small"
              />

              {/* Gotram */}
              <TextField
                label={`${text.gotram} *`}
                fullWidth
                value={gotram}
                onChange={(e) => setGotram(e.target.value)}
                disabled={!mobileValidated}
                variant="outlined"
                size="small"
              />

              {/* Family Total Members */}
              <TextField
                label={`${text.familyMembers} *`}
                fullWidth
                type="number"
                value={familyTotalMembers}
                onChange={(e) => setFamilyTotalMembers(e.target.value)}
                disabled={!mobileValidated}
                variant="outlined"
                size="small"
                inputProps={{ min: 1 }}
              />

              {/* How do you know about his family - Dropdown */}
              <FormControl fullWidth variant="outlined" size="small" disabled={!mobileValidated}>
                <InputLabel>{text.familyConnection} *</InputLabel>
                <Select
                  label={`${text.familyConnection} *`}
                  value={howYouKnowAboutFamily}
                  onChange={(e) => {
                    setHowYouKnowAboutFamily(e.target.value);
                    if (e.target.value !== 'Other') {
                      setHowYouKnowAboutFamilyOther('');
                    }
                  }}
                >
                  <MenuItem value="">
                    <em>{text.selectOption}</em>
                  </MenuItem>
                  <MenuItem value="Relative">{text.familyConnectionRelative}</MenuItem>
                  <MenuItem value="Coworker">{text.familyConnectionCoworker}</MenuItem>
                  <MenuItem value="Neighbors">{text.familyConnectionNeighbor}</MenuItem>
                  <MenuItem value="Other">{text.familyConnectionOther}</MenuItem>
                </Select>
              </FormControl>

              {/* Conditional "Other" textbox for how you know about family */}
              {howYouKnowAboutFamily === 'Other' && (
                <TextField
                  label={`${text.familyConnectionReason} *`}
                  fullWidth
                  value={howYouKnowAboutFamilyOther}
                  onChange={(e) => setHowYouKnowAboutFamilyOther(e.target.value)}
                  disabled={!mobileValidated}
                  variant="outlined"
                  size="small"
                />
              )}

              {/* Occupation - Dropdown */}
              <FormControl fullWidth variant="outlined" size="small" disabled={!mobileValidated}>
                <InputLabel>{text.occupation} *</InputLabel>
                <Select
                  multiple
                  label={`${text.occupation} *`}
                  value={occupation}
                  onChange={handleOccupationChange}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={text['occupation' + value]} size="small" />
                      ))}
                    </Box>
                  )}
                >
                  <MenuItem value="Vedam">{text.occupationVedam}</MenuItem>
                  <MenuItem value="Saastram">{text.occupationSaastram}</MenuItem>
                  <MenuItem value="Smaartham">{text.occupationSmaartham}</MenuItem>
                  <MenuItem value="Loukikam">{text.occupationLoukikam}</MenuItem>
                  <MenuItem value="Vantavaru">{text.occupationVantavaru}</MenuItem>
                </Select>
              </FormControl>

              {/* Category Display Space */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1, border: '1px dashed #ccc', borderRadius: 1, backgroundColor: '#fafafa' }}>
                {categoryInfo ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h5">{categoryInfo.icon}</Typography>
                    <Chip label={categoryInfo.label} sx={{ fontWeight: 700, backgroundColor: categoryInfo.color }} />
                  </Box>
                ) : (
                  <Typography variant="caption" color="text.secondary">
                    Category determined by occupation and background
                  </Typography>
                )}
              </Box>

              {/* Kids Education Type */}
              <FormControl fullWidth variant="outlined" size="small" disabled={!mobileValidated}>
                <InputLabel>{text.kidsEducation} *</InputLabel>
                <Select
                  label={`${text.kidsEducation} *`}
                  value={kidsEducationType}
                  onChange={(e) => setKidsEducationType(e.target.value)}
                >
                  <MenuItem value="">
                    <em>{text.selectOption}</em>
                  </MenuItem>
                  <MenuItem value="Vedam">{text.kidsEducationVedam}</MenuItem>
                  <MenuItem value="Saastram">{text.kidsEducationSaastram}</MenuItem>
                  <MenuItem value="Smaartham">{text.kidsEducationSmaartham}</MenuItem>
                  <MenuItem value="Loukikam">{text.kidsEducationLoukikam}</MenuItem>
                  <MenuItem value="NoKids">{text.noKids}</MenuItem>
                </Select>
              </FormControl>

              {!isLoukikam && (
                <>
                  {/* Agnihotram Question */}
                  <Box sx={{ gridColumn: '1 / -1' }}>
                    <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                      {text.hasAgnihotram} *
                    </Typography>
                    <RadioGroup
                      row
                      value={hasAgnihotram}
                      onChange={(e) => setHasAgnihotram(e.target.value)}
                    >
                      <FormControlLabel 
                        value="Yes" 
                        control={<Radio size="small" />} 
                        label={text.yes}
                        disabled={!mobileValidated}
                      />
                      <FormControlLabel 
                        value="No" 
                        control={<Radio size="small" />} 
                        label={text.no}
                        disabled={!mobileValidated}
                      />
                    </RadioGroup>
                  </Box>
                </>
              )}

              {/* Intercaste Marriage Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.intercasteMarriage} *
                </Typography>
                <RadioGroup
                  row
                  value={intercasteMarriageInThreeGenerations}
                  onChange={(e) => setIntercasteMarriageInThreeGenerations(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* Sandhya Vandanam Question - Full width */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.sandhyaVandanam} *
                </Typography>
                <RadioGroup
                  row
                  value={familySandhyaVandanam}
                  onChange={(e) => setFamilySandhyaVandanam(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* Son/Grandson Education Question - Full width */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.sonGrandsonEducation} *
                </Typography>
                <RadioGroup
                  row
                  value={sonGrandsonEducation}
                  onChange={(e) => setSonGrandsonEducation(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* hasAnushtanaMantras Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.hasAnushtanaMantras} *
                </Typography>
                <RadioGroup
                  row
                  value={hasAnushtanaMantras}
                  onChange={(e) => setHasAnushtanaMantras(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* belongsToGuruParampara Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.belongsToGuruParampara} *
                </Typography>
                <RadioGroup
                  row
                  value={belongsToGuruParampara}
                  onChange={(e) => setBelongsToGuruParampara(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* visitsVedaPathasala Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.visitsVedaPathasala} *
                </Typography>
                <RadioGroup
                  row
                  value={visitsVedaPathasala}
                  onChange={(e) => setVisitsVedaPathasala(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* daughtersMarriedToScholars Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.daughtersMarriedToScholars} *
                </Typography>
                <RadioGroup
                  row
                  value={daughtersMarriedToScholars}
                  onChange={(e) => setDaughtersMarriedToScholars(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* doesDasaraNavaratri Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.doesDasaraNavaratri} *
                </Typography>
                <RadioGroup
                  row
                  value={doesDasaraNavaratri}
                  onChange={(e) => setDoesDasaraNavaratri(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* followsMadiBhojanam Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.followsMadiBhojanam} *
                </Typography>
                <RadioGroup
                  row
                  value={followsMadiBhojanam}
                  onChange={(e) => setFollowsMadiBhojanam(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* performsVratasRegularly Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.performsVratasRegularly} *
                </Typography>
                <RadioGroup
                  row
                  value={performsVratasRegularly}
                  onChange={(e) => setPerformsVratasRegularly(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* hadFiveDayFunction Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.hadFiveDayFunction} *
                </Typography>
                <RadioGroup
                  row
                  value={hadFiveDayFunction}
                  onChange={(e) => setHadFiveDayFunction(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* doesDeeparadhana Question */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.doesDeeparadhana} *
                </Typography>
                <RadioGroup
                  row
                  value={doesDeeparadhana}
                  onChange={(e) => setDoesDeeparadhana(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="I don't know" 
                    control={<Radio size="small" />} 
                    label={text.iDontKnow}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* Committee Endorsed Member Question - Full width */}
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                  {text.isCommitteeEndorsed} *
                </Typography>
                <RadioGroup
                  row
                  value={isCommitteeEndorsed}
                  onChange={(e) => setIsCommitteeEndorsed(e.target.value)}
                >
                  <FormControlLabel 
                    value="Yes" 
                    control={<Radio size="small" />} 
                    label={text.yes}
                    disabled={!mobileValidated}
                  />
                  <FormControlLabel 
                    value="No" 
                    control={<Radio size="small" />} 
                    label={text.no}
                    disabled={!mobileValidated}
                  />
                </RadioGroup>
              </Box>

              {/* Submit Buttons - Full width */}
              <Box sx={{ gridColumn: '1 / -1', display: 'flex', gap: 2, pt: 2 }}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!areAllFieldsFilled() || submitting}
                  sx={{ backgroundColor: '#7f4b2d', px: 4 }}
                >
                  {submitting ? <CircularProgress size={24} sx={{ mr: 1 }} /> : text.submit}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setReferralMemberId('');
                    setMobileNumber('');
                    setFullNameWithoutSurname('');
                    setSurname('');
                    setGotram('');
                    setHowYouKnowAboutFamily('');
                    setHowYouKnowAboutFamilyOther('');
                    setFamilyTotalMembers('');
                    setOccupation('');
                    setKidsEducationType('');
                    setIntercasteMarriageInThreeGenerations('');
                    setFamilySandhyaVandanam('');
                    setSonGrandsonEducation('');
                    setHasAgnihotram('');
                    setIsCommitteeEndorsed('No');
                    setMobileValidated(false);
                    setHasAnushtanaMantras('I don\'t know');
                    setBelongsToGuruParampara('I don\'t know');
                    setVisitsVedaPathasala('I don\'t know');
                    setDaughtersMarriedToScholars('I don\'t know');
                    setDoesDasaraNavaratri('I don\'t know');
                    setFollowsMadiBhojanam('I don\'t know');
                    setPerformsVratasRegularly('I don\'t know');
                    setHadFiveDayFunction('I don\'t know');
                    setDoesDeeparadhana('I don\'t know');
                    setMobileCheckError('');
                    setErrorMessage('');
                  }}
                >
                  {text.clearForm}
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>

      {/* Existing Member Dialog */}
      <Dialog
        open={existingMemberDialog}
        onClose={() => setExistingMemberDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: '#7f4b2d', fontWeight: 700 }}>
          {text.memberAlreadyExists}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
            {text.memberDetails}
          </Typography>
          {existingMember && (
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1, rowGap: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.fullName}:
                </Typography>
                <Typography variant="body2">{existingMember.fullName}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.mobileNumber}:
                </Typography>
                <Typography variant="body2">{existingMember.mobileNumber}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.gotram}:
                </Typography>
                <Typography variant="body2">{existingMember.gotram}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.occupation}:
                </Typography>
                <Typography variant="body2">{existingMember.occupation}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.familyMembers}:
                </Typography>
                <Typography variant="body2">{existingMember.familyTotalMembers}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.kidsEducation}:
                </Typography>
                <Typography variant="body2">{existingMember.kidsEducationType}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.intercasteMarriage}:
                </Typography>
                <Typography variant="body2">{existingMember.intercasteMarriageInThreeGenerations}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.sandhyaVandanam}:
                </Typography>
                <Typography variant="body2">{existingMember.familySandhyaVandanam}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.sonGrandsonEducation}:
                </Typography>
                <Typography variant="body2">{existingMember.sonGrandsonEducation}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.hasAgnihotram}:
                </Typography>
                <Typography variant="body2">{existingMember.hasAgnihotram}</Typography>

                <Typography variant="caption" sx={{ fontWeight: 600, color: '#999' }}>
                  {text.isCommitteeEndorsed}:
                </Typography>
                <Typography variant="body2">{existingMember.isCommitteeEndorsed}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setExistingMemberDialog(false)} variant="contained" sx={{ backgroundColor: '#7f4b2d' }}>
            {text.close}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
